import {
  getImportTasks,
  getExportTasks,
} from '@/services/MusicLibrary/musiclibrary';

export default {
  namespace: 'SongCommon',

  state: {
    data: {
      list: [],
      pagination: {},
    },
    result: {},
  },

  effects: {
    *fetchImportTasks({ payload }, { call, put }) {
      const { status, data } = yield call(getImportTasks, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
    *fetchExportTasks({ payload }, { call, put }) {
      const { status, data } = yield call(getExportTasks, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    saveResult(state, { payload }) {
      return {
        ...state,
        result: payload,
      };
    },
  },
};
